import React from 'react';
import PriceCard from '../home/price/PriceCard';
import Back from "../common/Back";
import img from "../images/pricing.jpg";
import "../home/price/price.css";

function Pricing() {
  return (
    <>
      <section className='services mb'>
        <Back name='30 days money back guarantee' title='No Extra Fees. Friendly Support' cover={img} />
        <div className='price container'>
          <PriceCard />
        </div>
      </section>
    </>
  )
}

export default Pricing